module.exports = __webpack_public_path__ + "static/img/exploit12.f77d11fa.png";